import React, {useCallback} from 'react';
import {useSelector} from 'react-redux';
import {Navigate, Route, Routes, useNavigate} from 'react-router-dom';

import {ErrorBoundary} from '@sentry/react';
import {Skeleton} from 'src/components/skeleton';
import {ErrorPage} from 'src/modules/error-page/error-page.components';
import {API_TABS} from 'src/modules/profile/account/tabs/admin-account-api-v2/contants';
import {
    setupDataSelector,
} from 'src/modules/profile/account/tabs/admin-account-api-v2/views/controllers/setup/services/selectors';

import Loading from '@pb/kit-component-loading';

import {API_CALLS_TABS} from './constants';
import {IntegrationTab} from './integration/integration-tab';
import {PayPerCallTab} from './pay-per-call/pay-per-call-tab';
import {SubscriptionTab} from './subscription/subscription-tab';

type Props = {
    accountId: number,
};

export const CallsTab = ({accountId}: Props) => {
    const setupSetting = useSelector(setupDataSelector);
    const navigate = useNavigate();

    const baseRedirect = setupSetting?.crmIntegration
        ? API_CALLS_TABS.INTEGRATION.name
        : API_CALLS_TABS.SUBSCRIPTION.name;

    const onTabChange = useCallback((tab: string) => {
        navigate(`/profile/account/${accountId}/api/${API_TABS.CALLS.name}/${tab}`);
    }, [accountId, navigate]);

    return (
        <ErrorBoundary fallback={<ErrorPage subtitle="Please try again later." title="Calls page is unavailable"/>}>
            <Skeleton shown={!setupSetting} view={<Loading fast={true}/>}>
                <Routes>
                    <Route
                        path={`/${API_CALLS_TABS.SUBSCRIPTION.name}`}
                        element={<SubscriptionTab accountId={accountId} onTabChange={onTabChange}/>}
                    />
                    <Route
                        path={`/${API_CALLS_TABS.PAY_PER_CALL.name}`}
                        element={<PayPerCallTab accountId={accountId} onTabChange={onTabChange}/>}
                    />
                    <Route
                        path={`/${API_CALLS_TABS.INTEGRATION.name}`}
                        element={<IntegrationTab accountId={accountId} onTabChange={onTabChange}/>}
                    />

                    <Route
                        path="*"
                        element={(
                            <Navigate
                                to={`/profile/account/${accountId}/api/${API_TABS.CALLS.name}/${baseRedirect}`}
                                replace={true}
                            />
                        )}
                    />
                </Routes>
            </Skeleton>
        </ErrorBoundary>
    );
};
